import { render, staticRenderFns } from "./Reschedule.vue?vue&type=template&id=487b6f98&scoped=true"
import script from "./Reschedule.vue?vue&type=script&lang=js"
export * from "./Reschedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b6f98",
  null
  
)

export default component.exports